// const APP_ORIGIN = 'http://localhost:5500',
//     APP_EMBED_FRAME_URL = APP_ORIGIN + '/embed/embed.html',
//     APP_FORM_JS_URL = APP_ORIGIN + '/dist/js/tai-form.min.js',
//     APP_FORM_CSS_URL = APP_ORIGIN + '/dist/css/form.min.css';

// const APP_ORIGIN = 'http://localhost:9000',
//     APP_EMBED_FRAME_URL = APP_ORIGIN + '/embed/embed.html',
//     APP_FORM_JS_URL = 'http://localhost:9000/tai-form.min.js',
//     APP_FORM_CSS_URL = 'http://localhost:5500/dist/css/form.min.css';

// const APP_ORIGIN = 'https://form-tai.web.app',
//     APP_EMBED_FRAME_URL = APP_ORIGIN + '/embed/embed.html',
//     APP_FORM_JS_URL = 'https://form-tai.web.app/dist/js/tai-form.min.js',
//     APP_FORM_CSS_URL = 'https://form-tai.web.app/dist/css/form.min.js';


// const APP_ORIGIN = 'https://forms-staging.techatrium.com',
//     APP_EMBED_FRAME_URL = APP_ORIGIN + '/render/form-staging/embed/embed.html',
//     APP_FORM_JS_URL = APP_ORIGIN + '/render/form-staging/js/tai-form.min.js',
//     APP_FORM_CSS_URL = APP_ORIGIN + '/render/form-staging/css/form.min.css';

// const APP_ORIGIN = 'https://forms.techatrium.com',
//     APP_EMBED_FRAME_URL = APP_ORIGIN + '/render/form/embed/embed.html',
//     APP_FORM_JS_URL = APP_ORIGIN + '/render/form/js/tai-form.min.js',
//     APP_FORM_CSS_URL = APP_ORIGIN + '/render/form/css/form.min.css';

export const
    __ENV = __WP_TARGET_ENV,
    APP_ORIGIN = __WP_APP_ORIGIN,
    APP_EMBED_FRAME_URL = __WP_APP_EMBED_FRAME_URL,
    APP_FORM_JS_URL = __WP_APP_FORM_JS_URL,
    APP_FORM_CSS_URL = __WP_APP_FORM_CSS_URL,
    APP_DEFAULT_API_ENDPOINT = __WP_APP_API_ENPOINT;


